import { render } from "./AddBaseStationView.vue?vue&type=template&id=12666075&scoped=true"
import script from "./AddBaseStationView.vue?vue&type=script&lang=js"
export * from "./AddBaseStationView.vue?vue&type=script&lang=js"

import "./AddBaseStationView.vue?vue&type=style&index=0&id=12666075&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12666075"]])

export default __exports__